<template>
    <div class="footer_black" style="background-color:#EFEFEF; height:100%">
        <v-container class="d-flex justify-space-between py-10 footer_black align-center manage_font">
            <div class="sansation_title">Manage My Listings</div>
            <div class="sansation_subtitle">
                <v-btn text color="primary" @click="onOpenDeals">My Listings</v-btn>
                <v-btn text color="primary" @click="onCloseDetails">Close</v-btn>
            </div>
        </v-container>

        <div v-if="!readyToLoadListing" class="px-9">
            <v-card class="d-flex justify-center elevation-0" style="background-color:#EFEFEF">
                <v-progress-circular indeterminate color="primary" class="my-12" size="80" width="3"></v-progress-circular>
            </v-card>
        </div>

        <v-container v-if="readyToLoadListing" class="mb-9">
            <v-layout no-gutters row class="manage_font my-9">
                <v-flex md9 class="sansation_lg_title">
                    {{ listing.title }}: <span class="ml-3">{{ listing.listing_id }}</span>
                </v-flex>
                <v-flex md3 class="sansation text-right">
                    <a href="https://www.lending-well.com" target="_blank" class="warning_link">Find a Lender <v-icon small color="warning" class="ml-1">{{ icons.openInNewIcon }}</v-icon></a>
                </v-flex>
            </v-layout> 

            <v-layout no-gutters row class="my-9">
                <v-flex md3 class="d-flex flex-column">
                    <v-img :src="listing.img" contain></v-img>
                    <div class="d-flex flex-row">
                        <div alt="AUM" style="height: 74px; width: 28%;" class="d-flex flex-column align-center justify-center white--text error text-center">
                            <div class="d-block body-1 font-weight-thin px-1">{{ listing.aum_text }}</div>
                            <div class="d-block px-1 font-weight-medium">AUM</div>
                        </div>
                        <div alt="Revenue" style="height: 74px; width: 32%;" class="d-flex flex-column align-center justify-center white--text secondary text-center">
                            <div class="d-block body-1 font-weight-thin px-1">{{ listing.rev_text }}</div>
                            <div class="d-block px-1 font-weight-medium">Revenue</div>
                        </div>
                        <div alt="Type of Listing" style="height: 74px; width: 41%;" class="d-flex flex-column align-center justify-center white--text primary text-center">
                            <div class="d-block body-1 px-1 font-weight-medium">{{ listing.type_name }}</div>
                        </div>
                    </div>
                </v-flex>
                <v-flex md6 class="px-6 d-flex flex-column">
                    <div class="sansation_title font-weight-regular">My Status: <span class="font-weight-bold ml-2">{{ listing.buyer_status }}</span></div>
                    <div class="my-4">SRG's Listing Coordinator will be in contact with you via the email you provided with next steps.</div>
                    <div class="d-flex fill-height">
                        <a class="align-self-end" href="https://f.hubspotusercontent00.net/hubfs/6155808/%5BInfo%20Sheet%5D%20Buyer%20Program%202021.pdf" target="_blank">Download PDF Buyer Timeline</a>
                    </div>
                </v-flex>
                <v-flex md3 class="d-flex flex-column text-right">
                    <div class="sansation mb-3">Listing Stage: <span class="font-weight-bold ml-2">{{ listing.stage_name }}</span></div>
                    <div class="sansation my-3 font-weight-bold" v-html="listing.title"></div>
                    <div class="sansation_title my-3">{{ listing.listing_id }}</div>
                    <div class="d-flex fill-height justify-end">
                        <v-btn outlined large color="primary" class="sansation font-weight-bold align-self-end" href="mailto:anden.leesley@successionresourcegroup.com" target="_blank">Request Update</v-btn>
                    </div>
                </v-flex>
            </v-layout> 
        </v-container>

    </div>
</template>

<script>
    import axios from "axios";
import Cookie from "js-cookie";
    import appUrls from '../helpers/environment';
    import router from '../router';
    import { mdiOpenInNew } from '@mdi/js'

    let dateFormat = require('dateformat');
    import { toDollarsListings } from './utilities';

    export default {
        name: 'ManageDeals',
        props: [
            'listingId',
            'closeDetails',
            'quickViewDeals'
        ],
        data () {
            return {
                listing: [],
                readyToLoadListing: false,
                listing_statuses: [
                    {   value: 1, text: 'Open' },
                    {   value: 2, text: 'Pending' },
                    {   value: 3, text: 'Sold' },
                    {   value: 4, text: 'Closed' },
                ],
                listing_stages: [],
                listing_types: [],
                icons: {
                    openInNewIcon: mdiOpenInNew
                },
                buyer_statuses: []
            }
        },
        mounted () {
            this.getLists()

            setTimeout(() => {
                this.getThisListing()
            }, 3000);
        },
        methods: {
            onOpenDeals: function () {
                this.$emit('closeDetails', !this.closeDetails)
                this.$emit('quickViewDeals', !this.quickViewDeals)
            },

            onCloseDetails: function () {
                this.$emit('closeDetails', !this.closeDetails)
            },

            getThisListing: async function () {
                //console.log(this.listingId)
                axios.post(`${appUrls.api}/api/listing_detail/${this.listingId}`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    data: { 'user_id': Cookie.get('id') }
                })
                .then( res => {
                    if(res.data.outcome){
                        //console.log(res.data)
                        this.listing = res.data.listing;

                        //this.listing.post_date    = dateFormat(listing.post_date, "mm/dd/yyyy");
                        this.listing.listing_type   = this.listing.listing_type ? parseInt(this.listing.listing_type) : 0;
                        this.listing.status         = parseInt(this.listing.status);

                        // AUM TEXT
                        if (Number.parseFloat(this.listing.aum) >= 1000000) {
                            let aum_text = Number.parseFloat(this.listing.aum / 1000000).toFixed(1)
                            this.listing.aum_text = '$'+aum_text.replace(/\.?0*$/,'')+'M'
                        }else{
                            this.listing.aum_text = toDollarsListings(Number.parseFloat(this.listing.aum))
                        }
                        
                        // REVENUE TEXT
                        if (Number.parseFloat(this.listing.revenue) >= 1000000) {
                            let rev_text = Number.parseFloat(this.listing.revenue / 1000000).toFixed(1)
                            this.listing.rev_text = '$'+rev_text.replace(/\.?0*$/,'')+'M'
                        }else{
                            this.listing.rev_text = toDollarsListings(Number.parseFloat(this.listing.revenue))
                        }

                        // IMAGE
                        this.listing.img = require(`@/assets/listings/states/${this.listing.state}.jpg`)

                        // STATUS TEXT
                        let statusObj = this.listing_statuses.find(obj => parseInt(obj.value) === this.listing.status);
                        this.listing.status_name = statusObj.text;
                        
                        // STAGE TEXT
                        let lStageObj = this.listing_stages.find(obj => parseInt(obj.value) == this.listing.stage);
                        this.listing.stage_name = this.listing.stage != undefined ? lStageObj.text : '[Not Defined]';

                        // TYPE NAME
                        let typeObj = this.listing_types.find(obj => parseInt(obj.value) === this.listing.listing_type);
                        this.listing.type_name = this.listing.listing_type != 0 ? typeObj.text : '[Not Defined]';

                        // LOOK TO SEE IF THERE IS EVEN ANY RECORDS IN jbuyerstolistings FOR THIS USER & LISTING
                        let has_record = res.data.user_interest.find(row => row.listing_id === this.listing.id) ? true : false;
                        let interest_record = has_record ? res.data.user_interest.find(row => row.listing_id === this.listing.id) : false;

                        // INTERESTED
                        //console.log('has_record: '+has_record)
                        this.listing.interested     = has_record ? interest_record.interest ? true : false : false;
                        this.listing.interest_type  = has_record ? interest_record.interest ? "error" : "primary" : "primary";
                        this.listing.interest_text  = has_record ? interest_record.interest ? "Retract Interest" : "Express Interest" : "Express Interest";

                        // this.listing.interest_toggle = has_record ? "notshow" : "show";
                        // this.listing.interest_type   = has_record ? "error" : "primary";
                        // this.listing.interest_text   = has_record ? "I'm Interested" : "Express Interest";

                        // OFFER
                        //console.log('interest_record.offer: '+interest_record.offer)
                        this.listing.offer_made = interest_record ? interest_record.offer ? true : false : false;
                        this.listing.offer_type = interest_record ? interest_record.offer ? "error" : "primary" : "primary";
                        this.listing.offer_text = interest_record ? interest_record.offer ? 'Offer Made' : 'Make An Offer' : 'Make An Offer';

                        // FAV
                        // this.listing.fav        = interest_record ? interest_record.fav ? true : false : false;
                        // this.listing.fav_color  = interest_record ? interest_record.fav ? "warning" : "#999" : "#999";

                        // BUYER STATUS
                        // console.log(res.data.user_interest[0])
                        let bStatusObj = this.buyer_statuses.find(obj => parseInt(obj.value) == res.data.user_interest[0].status_id);
                        this.listing.buyer_status = bStatusObj ? bStatusObj.text : '';

                        //console.log(this.listing)
                        this.readyToLoadListing = true;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            getLists: function () {
                let optionsLists = [ 
                    {'name': 'listing_types', 'type': 'int'}, 
                    {'name': 'listing_stages', 'type': 'txt'}, 
                    {'name': 'buyer_status', 'type': 'desc'} 
                ];
                
                axios.post(`${appUrls.api}/api/lists`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    list_options: optionsLists
                })
                .then( res => {
                    //console.log(res.data)
                    if(res.data.outcome){
                        let arrLists = res.data.lists;
                        // SET PROPERTIES WITH THIER APPROPRIATE LIST
                        for (let l in arrLists) {
                            if (arrLists[l].name == 'buyer_status') this.buyer_statuses = arrLists[l].list
                            if (arrLists[l].name == 'listing_types') this.listing_types = arrLists[l].list
                            if (arrLists[l].name == 'listing_stages') this.listing_stages = arrLists[l].list
                        }
                        //console.log(this.buyer_statuses, this.listing_types, this.listing_stages)
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* .deal_details {
        height:100%;
        background-color:#FFF;
    } */
    .sansation_lg_title {
        font-family: 'Sansation';
        font-size: 2.2rem!important;
    }
    .manage {
        border-bottom: 1px solid #CCEAED;
    }
    .manage_font {
        font-size: 1.1rem!important;
        font-weight: 600;
        letter-spacing: .03125em!important;
        color: #5F6062;
    }
    .warning_link {
        text-decoration-line: none;
        color: #F1563F; /* warning */
    }
    .v-application .button_link {
        text-decoration-line: none;
        color: #5F6062;
    }
    .v-application .active_link {
        text-decoration-line: none;
        font-weight: 800;
        color: #0096A6;
        border-bottom: 5px solid #0096A6;
    }
</style>


// WEBPACK FOOTER //
// src/components/ManageDeals.vue